import { signal } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CatalogPage } from '../models/catalog.model';

export class RemoteCatalog<T> {
  private readonly _items = signal<readonly T[]>([]);
  private readonly _hasMore = signal(false);
  private readonly _loading = signal(false);
  private subscription: Subscription | undefined;
  private lastTerm: string | null = null;

  readonly items = this._items.asReadonly();
  readonly hasMore = this._hasMore.asReadonly();
  readonly loading = this._loading.asReadonly();

  constructor(private readonly fetch: (term: string) => Observable<CatalogPage<T>>) {}

  search(term: string): void {
    const normalized = term.trim();
    if (normalized === this.lastTerm) return;

    this.subscription?.unsubscribe();
    this.lastTerm = normalized;
    this._loading.set(true);

    this.subscription = this.fetch(normalized).subscribe({
      next: (page) => this.settle(page.items, page.hasMore),
      error: () => {
        this.lastTerm = null;
        this.settle([], false);
      },
    });
  }

  reset(): void {
    this.subscription?.unsubscribe();
    this.subscription = undefined;
    this.lastTerm = null;
    this.settle([], false);
  }

  private settle(items: readonly T[], hasMore: boolean): void {
    this._items.set(items);
    this._hasMore.set(hasMore);
    this._loading.set(false);
  }
}
